import styled from 'styled-components'

const AbstractMouseEffectStyle = styled.div`
	--ameMarginV: var(--sp69x);
	--ameInfoMaxWidth: var(--sp141x);
	--ameTitleMarginBottom: var(--sp7x);
	--ameImagePortraitWidth: 42.57%;
	--ameImageLandscapeWidth: 27.38%;
	--ameImagePortraitProportion: 137.5%;
	--ameImageLandscapeProportion: 100%;

	--ameImage1Bottom: var(--sp9x);
	--ameImage1Right: var(--sp18x);

	--ameImage2Bottom: var(--sp8x);
	--ameImage2Right: var(--sp16x);

	--ameImage3Top: calc(-1 * var(--sp50x));
	--ameImage3Right: var(--sp6x);

	--ameImage4Top: var(--sp9x);
	--ameImage4Left: 0px;

	--ameImage5Bottom: var(--sp9x);
	--ameImage5Left: var(--sp29x);

	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--primaryColor3);
	text-align: center;
	overflow: hidden;

	.ame-info-container {
		position: relative;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		max-width: var(--ameInfoMaxWidth);
		margin: var(--ameMarginV) 0;

		.ame-title {
			margin-bottom: var(--ameTitleMarginBottom);
		}

		.hidden-container {
			z-index: 2;
		}

		.ame-image {
			position: absolute;
			border-radius: var(--sp2x);
			overflow: hidden;

			&.ame-image-portrait {
				width: var(--ameImagePortraitWidth);

				.imageCont {
					--imagePaddingTop: var(--ameImagePortraitProportion);
				}
			}

			&.ame-image-landscape {
				width: var(--ameImageLandscapeWidth);

				.imageCont {
					--imagePaddingTop: var(--ameImageLandscapeProportion);
				}
			}

			&.ame-image-1 {
				bottom: calc(100% + var(--ameImage1Bottom));
				right: calc(100% + var(--ameImage1Right));
			}

			&.ame-image-2 {
				bottom: calc(100% + var(--ameImage2Bottom));
				right: var(--ameImage2Right);
			}

			&.ame-image-3 {
				top: calc(100% + var(--ameImage3Top));
				right: calc(100% + var(--ameImage3Right));
			}

			&.ame-image-4 {
				top: calc(100% + var(--ameImage4Top));
				left: calc(100% + var(--ameImage4Left));
			}

			&.ame-image-5 {
				bottom: var(--ameImage5Bottom);
				left: calc(100% + var(--ameImage5Left));
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--ameMarginV: var(--sp49x);
		--ameInfoMaxWidth: var(--sp106x);
		--ameTitleMarginBottom: var(--sp6x);
		--ameImagePortraitWidth: 42.57%;
		--ameImageLandscapeWidth: 27.38%;

		--ameImage1Bottom: var(--sp7x);
		--ameImage1Right: var(--sp13x);

		--ameImage2Bottom: var(--sp6x);
		--ameImage2Right: var(--sp9x);

		--ameImage3Top: calc(-1 * var(--sp35x));
		--ameImage3Right: var(--sp4x);

		--ameImage4Top: var(--sp4x);
		--ameImage4Left: 0px;

		--ameImage5Bottom: var(--sp9x);
		--ameImage5Left: var(--sp22x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--ameMarginV: var(--sp39x);
		--ameInfoMaxWidth: var(--sp83x);
		--ameTitleMarginBottom: var(--sp6x);
		--ameImagePortraitWidth: 42.57%;
		--ameImageLandscapeWidth: 27.38%;

		--ameImage1Bottom: var(--sp4x);
		--ameImage1Right: var(--sp10x);

		--ameImage2Bottom: var(--sp4x);
		--ameImage2Right: var(--sp8x);

		--ameImage3Top: calc(-1 * var(--sp25x));
		--ameImage3Right: var(--sp6x);

		--ameImage4Top: var(--sp4x);
		--ameImage4Left: 0px;

		--ameImage5Bottom: var(--sp9x);
		--ameImage5Left: var(--sp18x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--ameMarginV: var(--sp39x);
		--ameInfoMaxWidth: var(--sp83x);
		--ameTitleMarginBottom: var(--sp6x);
		--ameImagePortraitWidth: 42.57%;
		--ameImageLandscapeWidth: 27.38%;

		--ameImage1Bottom: var(--sp4x);
		--ameImage1Right: var(--sp10x);

		--ameImage2Bottom: var(--sp5x);
		--ameImage2Right: var(--sp8x);

		--ameImage3Top: calc(-1 * var(--sp25x));
		--ameImage3Right: var(--sp6x);

		--ameImage4Top: var(--sp4x);
		--ameImage4Left: var(--sp4x);

		--ameImage5Bottom: var(--sp14x);
		--ameImage5Left: var(--sp14x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--ameMarginV: var(--sp34x);
		--ameInfoMaxWidth: var(--sp65x);
		--ameTitleMarginBottom: var(--sp5x);
		--ameImagePortraitWidth: 54.23%;
		--ameImageLandscapeWidth: 29.8%;

		--ameImage1Bottom: var(--sp4x);
		--ameImage1Right: var(--sp15x);

		--ameImage2Bottom: var(--sp5x);
		--ameImage2Right: var(--sp4x);

		--ameImage3Top: calc(-1 * var(--sp30x));
		--ameImage3Right: var(--sp5x);

		--ameImage4Top: var(--sp4x);
		--ameImage4Left: var(--sp4x);

		--ameImage5Bottom: var(--sp5x);
		--ameImage5Left: var(--sp12x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--ameMarginV: var(--sp38x);
		--ameInfoMaxWidth: var(--sp60x);
		--ameTitleMarginBottom: var(--sp4x);
		--ameImagePortraitWidth: 56.72%;
		--ameImageLandscapeWidth: 32.29%;

		--ameImage1Bottom: var(--sp8x);
		--ameImage1Right: var(--sp7x);

		--ameImage2Bottom: var(--sp4x);
		--ameImage2Right: var(--sp4x);

		--ameImage3Top: calc(-1 * var(--sp38x));
		--ameImage3Right: var(--sp12x);

		--ameImage4Top: var(--sp4x);
		--ameImage4Left: 0px;

		--ameImage5Bottom: var(--sp6x);
		--ameImage5Left: var(--sp12x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--ameMarginV: var(--sp35x);
		--ameInfoMaxWidth: var(--sp60x);
		--ameTitleMarginBottom: var(--sp4x);
		--ameImagePortraitWidth: 56.72%;
		--ameImageLandscapeWidth: 32.29%;

		--ameImage1Bottom: var(--sp8x);
		--ameImage1Right: calc(-1 * var(--sp9x));

		--ameImage2Bottom: var(--sp4x);
		--ameImage2Right: var(--sp10x);

		--ameImage3Top: calc(-1 * var(--sp30x));
		--ameImage3Right: var(--sp5x);

		--ameImage4Top: var(--sp4x);
		--ameImage4Left: calc(-1 * var(--sp1x));

		--ameImage5Bottom: var(--sp4x);
		--ameImage5Left: var(--sp5x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--ameMarginV: var(--sp35x);
		--ameInfoMaxWidth: var(--sp45x);
		--ameTitleMarginBottom: var(--sp4x);
		--ameImagePortraitWidth: 53.17%;
		--ameImageLandscapeWidth: 43.08%;

		--ameImage1Bottom: var(--sp10x);
		--ameImage1Right: calc(-1 * var(--sp20x));

		--ameImage2Bottom: var(--sp4x);
		--ameImage2Right: calc(-1 * var(--sp8x));

		--ameImage3Top: var(--sp10x);
		--ameImage3Right: calc(-1 * var(--sp16x));

		--ameImage4Top: var(--sp10x);
		--ameImage4Left: calc(-1 * var(--sp18x));

		.ame-info-container {
			margin-bottom: var(--sp48x);
		}
	}
`

export default AbstractMouseEffectStyle
